import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Which societies are live in Bangalore?",
    a: "We're piloting in 7 societies in Akshay Nagar — including gated mid-rise and high-rise communities — and rapidly onboarding more across South Bangalore. Join the waitlist with your society name and we'll fast-track approvals.",
  },
  {
    q: "Is waterless safe for premium paint?",
    a: "Yes. Our nano-polymer formulations are SAE-tested and used by official detailers for marques like Porsche and Audi. The encapsulating agents lift dirt without micro-scratching the clear coat.",
  },
  {
    q: "What happens if my car is damaged during a wash?",
    a: "Every visit has before/after photo verification. If something happens, raise a dispute in-app — we run a 24-hour investigation. Premium and Luxury plans include damage insurance up to ₹50k and ₹2L respectively.",
  },
  {
    q: "Can I pause or cancel my subscription?",
    a: "Anytime, no questions asked. Pause for vacations, cancel from the app. There are no contracts, no lock-ins. We earn your business every month.",
  },
  {
    q: "Who are the Zyppers?",
    a: "Background-verified, trained professionals — never gig drifters. They go through a 5-day certification programme, get a uniform, insurance, and a tier system that rewards skill.",
  },
];

export default function FAQs() {
  return (
    <section
      id="faqs"
      data-testid="faq-accordion"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.22em] text-[#FF5A00] mb-4">
            FAQs
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base md:text-lg font-medium text-white hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed pb-6 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
